import React from "react";
import FixedIntervals from "features/CalendarView/FixedIntervals";
import {setIsChangingDayFromNonScrollEvent} from "shared/itemLists/redux/itemListsSlice"
import store from "glassRedux/store"

export default class FixedIntervalsShared extends React.Component {
  constructor(props) {
    super(props);
    this.setToInterval = this.setToInterval.bind(this);
  }
  setToInterval(params) {
    const {
      setSelectedDate,
      isCalReversed,
      dateHelper,
      setIsSomeday,
    } = this.props;

    let interval;
    if (params.interval) {
      interval = params.interval;
    } else {
      interval = params.target.innerHTML;
    }
    const dir = isCalReversed ? -1 : 1;
    switch (interval) {
      case "Today":
        setSelectedDate(dateHelper.date);
        break;
      case "6w":
        setSelectedDate(dateHelper.interval(6 * dir, "weeks"));
        break;
      case "3m":
        setSelectedDate(dateHelper.interval(3 * dir, "months"));
        break;
      case "6m":
        setSelectedDate(dateHelper.interval(6 * dir, "months"));
        break;
      case "1y":
        setSelectedDate(dateHelper.interval(1 * dir, "years"));
        break;
      case "Someday":
        setSelectedDate(dateHelper.someday);

        setIsSomeday(true);
        break;
      default:
        throw Error("unable to scroll to unknown interval");
    }
    store.dispatch(setIsChangingDayFromNonScrollEvent(true))
  }

  render() {
    const { isSomedayDisabled } = this.props;

    return (
      <FixedIntervals
        setToInterval={this.setToInterval}
        isSomedayDisabled={isSomedayDisabled}
      />
    );
  }
}
